import { render, staticRenderFns } from "./oldManFileThird.vue?vue&type=template&id=405bf64e&scoped=true&"
import script from "./oldManFileThird.vue?vue&type=script&lang=js&"
export * from "./oldManFileThird.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileThird.vue?vue&type=style&index=0&id=405bf64e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405bf64e",
  null
  
)

export default component.exports